export default [
    {
        path: '/np/bulkImport',
        name: 'import',
        component: () => import('views/modules/np/bulkImport/index'),
        meta: {
            parent: '/npmanager',
            icon: 'el-icon-document',
            title: '批量导入',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    }, 
    {
        path: '/np/bulkImport/record',
        name: 'import',
        component: () => import('views/modules/np/bulkImport/record/index'),
        meta: {
            parent: '/np/bulkImport',
            icon: 'el-icon-document',
            title: '导入记录',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    },
];